import useSWR from "swr";
import { UserService } from "../../api/userService/UserService";
import { SwrKeys } from "./keys";
var useHeaderInfo = function (payload) {
    var _a = useSWR((payload === null || payload === void 0 ? void 0 : payload.userId) ? SwrKeys.HEADER_INFO : null, function () { return UserService.getHeaderInfo(payload); }, {
        revalidateOnMount: true,
        revalidateOnFocus: false,
    }), headerInfo = _a.data, error = _a.error, isLoading = _a.isLoading;
    return { headerInfo: headerInfo, error: error, isLoading: isLoading };
};
export default useHeaderInfo;
